const styles = theme => ({
  filtersContainer: {
    padding: '0 !important',
  },
  divider: {
    margin: '24px 0',
    [theme.breakpoints.down('sm')]: {
      margin: '16px 0',
    },
  },
  fetchBtnHolder: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  fetchBtn: {
    backgroundColor: theme.palette.primary.adgmBlack,
    borderColor: theme.palette.primary.adgmBlack,
    '&:focus': {
      backgroundColor: theme.palette.primary.adgmBlack,
      borderColor: theme.palette.primary.adgmBlack,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.adgmBlack,
      borderColor: theme.palette.primary.adgmBlack,
    },
  },
});

export default styles;
